import { useSelection } from "@frend-digital/centra/client";

export const useCurrency = () =>
	useSelection({
		select: (data) => data.selection?.currency,
	});
